const isObject = (value) => value != null && (typeof value == 'object' || typeof value == 'function');

const camelizeCase = function(str) {
  return str.replace(/[-_\s]+(.)?/g, function(match, c) {
    return c ? c.toUpperCase() : '';
  });
};

const camelizeObject = function(object) {
  return Object.keys(object || {}).reduce(function(memo, key) {
    const value = object[key];
    const newValue = isObject(value) ? camelizeObject(value) : value;
    memo[camelizeCase(key)] = newValue;
    return memo;
  }, {});
};

const camelize = function(param) {
  switch (typeof param) {
    case 'string':
      return camelizeCase(param);
    case 'object':
      return camelizeObject(param);
    default:
      return param;
  }
};

export default camelize;
